import { Skeleton } from '@/shared/components/ui/skeleton'

/**
 * Route-level Suspense fallback: a page-shaped skeleton (header bar + content
 * blocks). Use the SAME component for every Suspense stage on a route (the
 * feature-chunk fallback in app/router.tsx AND the page-chunk fallback in the
 * feature's routes file) so a navigation shows one steady loading surface
 * instead of a spinner → differently-shaped skeleton → page chain, where each
 * hand-off unmounts one loader and mounts another with a layout jump.
 */
export function PageSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-4)', padding: 'var(--sp-4) 0' }}>
      <Skeleton height={40} rounded="md" />
      <Skeleton height={200} rounded="lg" />
      <Skeleton height={300} rounded="lg" />
    </div>
  )
}
